import { BreakdownTypes } from '@wix/cashier-express-checkout-widget/dist/src/types/PaymentBreakdown';
export const DEFAULT_AMOUNT = '10';
export function getEstimatedPaymentData(estimatedTotal) {
  if (estimatedTotal === void 0) {
    estimatedTotal = DEFAULT_AMOUNT;
  }
  const orderItems = [{
    id: 'id',
    name: '-',
    price: estimatedTotal,
    quantity: 1
  }];
  const paymentBreakdown = {
    [BreakdownTypes.ItemsTotal]: estimatedTotal,
    [BreakdownTypes.Shipping]: '0',
    [BreakdownTypes.Tax]: '0',
    [BreakdownTypes.Discount]: '0'
  };
  const paymentAmount = estimatedTotal;
  return {
    orderItems,
    paymentBreakdown,
    paymentAmount
  };
}
//# sourceMappingURL=getEstimatedPaymentData.js.map